import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Popconfirm, Upload, message } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

const baseUrl = process.env.REACT_APP_API_BASE_URL

const UploadImage = ({ onChange, defaultValueImg, text = 'Upload' }) => {
  const [loading, setLoading] = useState(false)
  const [imageUrls, setImageUrls] = useState([])

  useEffect(() => {
    if (defaultValueImg) {
      setImageUrls(defaultValueImg)
    }
  }, [defaultValueImg])

  const handleChange = (info) => {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }

    if (info.file.status === 'done') {
      // const data = info.fileList.map((file) => file.response.storageUrl)
      const data = [...imageUrls, info.file.response.storageUrl]
      setImageUrls(data)
      setLoading(false)
      onChange(data)
      return data
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">{text}</div>
    </div>
  )

  const urls = imageUrls

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }

    return isJpgOrPng && isLt2M
  }

  return (
    <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
      <Upload
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        action={`${baseUrl}/container/upload`}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        accept=".jpg,.png,.jpeg"
        headers={{
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }}
      >
        {uploadButton}
      </Upload>
      {urls.map((url) => (
        <Popconfirm
          key={url}
          title="คุณแน่ใจว่าจะลบรูปนี้"
          onConfirm={() =>
            setImageUrls((v) => {
              const newData = v.filter((i) => i !== url)
              onChange(newData)
              return newData
            })
          }
          // onCancel={}
          okText="ลบ"
          cancelText="ยกเลิก"
        >
          <img
            src={url}
            alt="avatar"
            style={{ width: 104, height: 104, cursor: 'pointer' }}
          />
        </Popconfirm>
      ))}
    </div>
  )
}

// UploadComponent.propTypes = {
//   imageUrl: PropTypes.string,
//   defaultValueImg: PropTypes.object,
//   uploadButton: PropTypes.node,
//   handleChange: PropTypes.func,
// }

UploadImage.propTypes = {
  defaultValueImg: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
  text: PropTypes.string,
  onChange: PropTypes.func,
}

export default UploadImage
